'use strict';

import { appState } from './appState.js';
import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';
import { makePromise, sleep } from './asyncTools.js';
import { optionsMenu } from './optionsMenu.js';
import { crypterReady, getCrypter, initCrypter, setGlobalCrypter } from './crypter.js';
import { SecureEncryptionV02 } from './SecureEncryptionV02.js';
import { urlSafe } from './urlTools.js';

async function archiveRestore(data) {

    var lockInitPromise = makePromise();
    var fnStatus = (status) => {
        if (status === 'acquired') {
            lockInitPromise.resolve();
            return;
        }

        if (status === 'locked') {
            //throw new Error('Could not acquire lock');
            lockInitPromise.reject();
        }
    };
    const globalLock = await window.AppBridge.getGlobalLock();
    if (globalLock) {
        globalLock.lockWhileUnlock(fnStatus);
    }

    await lockInitPromise.promise;
    if (lockInitPromise.isRejected()) {
        throw new Error('Couldnt acquire lock');
    }

    console.log('ARCHIVE RESTORE: START, LOCKED');

    var success = false;
    var pinSaveFromArchive = false;
    var archiveCrypter;
    var archivePin = null;

    let done = false;
    let onDone = async function() {
        if (pinSaveFromArchive) {
            // saglabājam pin ja vajag;
            var response = await appState.globalCrypter.sendServerPartToServer(false, {
                newPin: 1,
                pinChangeFromId: 0,
                withConvert: 0,
                fromArchive: 1
            });
        }

        $('.if-pinConvertingDone').show();
        $('.if-pinConvertingDoneNOPIN').toggle(!pinSaveFromArchive);
        $('.if-pinConvertingDonePIN').toggle(pinSaveFromArchive);
        $('.if-pinConverting').hide();
    };

    const archiveRestorePromise = new Promise(async (resolve, reject) => {
        // Vispirms pārbaudam vai eksistē globālais PIN un vai tas ir ievadīts;
        const currentCrypter = getCrypter();
        const currentStatus = await crypterReady(currentCrypter);
        if (currentStatus == 'createPIN') {
            pinSaveFromArchive = true;
            resolve();
        } else {
            // Ja PIN nav ievadīts, liekam to ievadīt;
            await initCrypter({
                from: 'archive',
                skippable: false,
                pinEnterTitle: data.pinEnterTitle1,
                enterOptions: {
                    withoutLock: true
                },
                createOptions: {
                    withoutLock: true
                }
            }).catch(() => {
                reject('Current Pin input canceled');
            });
            await sleep(250);
            resolve();
        }
    }).then(() => new Promise(async (resolve, reject) => {
        archiveCrypter = new SecureEncryptionV02('user', {
            temp: true,
            subId: 'archive'+data.cryptId
        });
        await archiveCrypter.initializeCryptAuth({
            type: 'user',
            sessionHash: false,
            crypt: {
                ready: 0,
                status: 0,
                cryptId: data.cryptId,
                hash: data.hash,
                ttl: null
            },
            addData: {
                archiveId: data.archiveId
            }
        });
        if (data.setVerifyStatus) {
            archiveCrypter.setVerifyStatus(data.setVerifyStatus);
        }

        // šis gaidīs kamēr ievadīs arhīva PIN;
        await initCrypter({
            from: 'archive',
            skippable: false,
            pinInputCallback: (pin) => {
                archivePin = pin;
            },
            crypter: archiveCrypter,
            pinEnterTitle: data.pinEnterTitle0,
            enterOptions: {
                withoutLock: true,
                withoutForgot: true
            }
        }).catch(() => {
            reject('Archive Pin input canceled');
        });

        resolve();
    })).then(() => new Promise(async (resolve, reject) => {
        if (pinSaveFromArchive) {
            // notestējam pin save bet vēl nesaglabājam
            var response = await archiveCrypter.sendServerPartToServer(false, {
                newPin: 1,
                pinChangeFromId: 0,
                withConvert: 0,
                isTest: 1
            });
            if (response.ok) {
                await setGlobalCrypter(archiveCrypter, archivePin);
            }
        }
        resolve();
    })).then(() => new Promise(async (resolve, reject) => {
        await ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: 'cryptAuthCONVERTloading'
            },
            success: async function(data) {
                await ResponseDispatcher.handle(data);
                if (data.ok) {
                    done = true;
                }
            },
            dataType: 'json'
        });

        if (!done) {
            reject();
            return;
        }

        $('body').on('click', '[data-action="continue-from-loading"]', function(){
            if (!$(this).hasClass('disabled')) {
                urlSafe.reload();
            }
        });

        await sleep(50);
        $('.if-pinConvertingDone').hide();
        $('.if-pinConvertingDoneNOPIN').hide();
        $('.if-pinConvertingDonePIN').hide();
        $('.if-pinConverting').show();

        const CryptConvert = await window.AppBridge.CryptConvert();
        var converter = new CryptConvert({
            type: 3, // no arhīva uz profila
            decrypter: archiveCrypter, // no arhīva
            encrypter: getCrypter(), // uz globālo
            addData: {
                archiveId: data.archiveId,
                fromCryptId: data.cryptId,
                initLoading: 1
            },
            onDone: onDone,
            loadingSel: '.pinConvertingLoading2'
        });
        await converter.convert();
        await converter.convertPromise;

        resolve();
    }));

    await archiveRestorePromise.catch((error) => {
        console.log('archiveRestorePromise error:', error.message || error);
    });

    if (archiveCrypter) {
        // @ts-ignore
        archiveCrypter.clear();
    }

    console.log('ARCHIVE RESTORE: DONE, UNLOCK');
    if (globalLock) {
        globalLock.unlock(success ? 'done' : 'cancel');
    }

    return archiveRestorePromise;
}


export function loadArchive() {

    $('body').on('click', '.jqarchiveitem', function(event) {
        event.preventDefault();

        optionsMenu.open({
            action: 'open',
            el: this,
            event: event
        });
    });

    $('body').on('click', '.jqarchive', function(event) {
        //event.stopPropagation();
        const action = $(this).data('action');

        // @ts-ignore
        var thisId = $(this).data('id') || $($(this).closest('.cht2fld-options').get(0).targetEl).closest('.ax-it').data('id');
        var addData = {};

        if (action == 'archive-delete-confirm') {
            addData.deleteConfirm = 1;
        }

        ajaxWrapNew({
            method: 'POST',
            data: $.extend({
                ajax: 1,
                action: action,
                id: thisId
            }, addData),
            success: function(data) {
                ResponseDispatcher.handle(data, action);
                try {
                    if (data.ok) {
                        optionsMenu.close();

                        setTimeout(() => {
                            if (data.archiveRemoved) {
                                $('.ax-it[data-id="' + data.archiveRemoved + '"]').remove();
                            }
                            if (data.archiveRestore) {
                                archiveRestore(data.archiveRestore);
                            }
                        }, 50);
                    }
                } catch (e2) {
                    console.log( e2 );
                }
            },
            dataType : 'json'
        });
    });

    $('body').on('click', '[data-action="archive-delete"]', function(event) {
        event.stopPropagation();
    });

    $('body').on('click', '.jqarchivenew', function(event) {
        event.stopPropagation();
        const action = $(this).data('action');
        if (action === 'archiveData' || action === 'archiveData-confirm') {
            ajaxWrapNew({
                method: 'POST',
                data: {
                    ajax: 1,
                    action: action,
                    archiveConfirm: action === 'archiveData-confirm' ? 1 : 0
                },
                success : function( data ) {
                    ResponseDispatcher.handle(data, action);
                },
                dataType : 'json'
            });
        }
    });

    /* $('body').on('click', '[data-action="back"]', function(event) {
        event.stopPropagation();
        history.back();
    }); */

}
